const filterCallback = ({ data }) => {
  const { title, webp = '', image = '', content = '', link = '' } =
    data[0] || {};
  return {
    title,
    imagePathWebp: webp,
    imagePath: image,
    content,
    link
  };
};

export default filterCallback;
